import { useState, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useModalTxError(lastTransaction) {
  const { t } = useTranslation();
  const [weDispatchedTx, setWeDispatchedTx] = useState(false);

  const clearError = useCallback(() => {
    setWeDispatchedTx(false);
  }, []);

  const wrapDispatch = useCallback(
    (fn) => () => {
      setWeDispatchedTx(true);
      fn();
    },
    []
  );

  const errorToShow = useMemo(() => {
    if (!weDispatchedTx || !lastTransaction?.error) return undefined;

    const rawError = lastTransaction.error.toString().toLowerCase();

    if (rawError.includes("rejected") || rawError.includes("user denied") || rawError.includes("4001")) {
      return t("Transaction cancelled by user.");
    }

    if (rawError.includes("insufficient funds") || rawError.includes("exceeds balance")) {
      return t("You don't have enough ETH for gas fees.");
    }

    if (rawError.includes("allowance") || rawError.includes("amount exceeds")) {
      return t("Approval error. Please try signing again.");
    }

    if (rawError.includes("network") || rawError.includes("disconnected")) {
      return t("Network error. Please check your connection.");
    }

    return t("Something went wrong. Please try again.");
  }, [weDispatchedTx, lastTransaction, t]);

  return { errorToShow, clearError, wrapDispatch };
}
